@if (busy) {
  <div class="loading-image-container">
    <div class="loading-image small"></div>
    <div class="loading-text">{{ busyMessage }}</div>
  </div>
}
<div class="tile-wrapper">
  <mat-card>
    <mat-card-title
      >Delete Tenant "{{
      viewModel ? viewModel?.TenantName : ""
      }}"</mat-card-title
      >
    </mat-card>

    @if (viewModel) {
      <div>
        <mat-card>
          <mat-card-content>
            @if (!processComplete) {
              <div class="content-wrapper">
                <h3>
                  <mat-icon>warning</mat-icon>&nbsp; Deleting a Tenant is
                  irreversible. Are you sure?
                </h3>
              </div>
            }
            @if (viewModel.RequestError && viewModel.Failed) {
              <div>
                <h3 class="error">Request Error</h3>
                <p>
                  <span class="error">
                    <mat-icon>highlight_off</mat-icon> {{ viewModel.RequestError }}
                  </span>
                </p>
              </div>
            }
            @if (!viewModel.Failed && processComplete) {
              <div>
                <h3 class="no-top-margin">Process Complete</h3>
                <div class="card-content">
                  <mat-icon class="no-error">check_circle</mat-icon>
                  Tenant "{{ viewModel.TenantName }}" has been deleted
                </div>
              </div>
            }
            @if (viewModel.TenantName && !processComplete) {
              <div>
                <button
                  mat-raised-button
                  color="warn"
                  (click)="showDeleteConfirmationDialog()"
                  >
                  <mat-icon>delete</mat-icon>Yes, delete it
                </button>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>
